'use strict';

let ParsleyEventsView = require('./ParsleyEventsView');

class ParsleyEvents {
    constructor() {
        this.view = new ParsleyEventsView();
    }

    registerValidator() {
        window.Parsley.on('field:error', fieldInstance => {
             this.view.showFieldErrors(fieldInstance.getErrorsMessages(), fieldInstance.$element, fieldInstance.$element.attr('id'));
        });

        window.Parsley.on('field:success', fieldInstance => {
            this.view.removeFieldErrors(fieldInstance.getErrorsMessages(), fieldInstance.$element, fieldInstance.$element.attr('id'));
        });

        window.Parsley.on('form:validate', () => this.view.formValidate());
    }
}

module.exports = ParsleyEvents;